import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/authprovider';

import '../styles/SignInPage.css';
import '../styles/buttons.css';

import { auth } from "../config/firebase";
import {
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword
} from "firebase/auth";

import GoogleLogo from '../assets/Google_logo.png';

export default function SignInPage() {
  const [email, setEmail]             = useState('');
  const [password, setPassword]       = useState('');
  const [emailError, setEmailError]   = useState('');
  const [passwordError, setPasswordError] = useState('');
  const navigate                      = useNavigate();
  const provider                      = new GoogleAuthProvider();
  const { login }                     = useAuth();  // <-- our context

  const handlePostSignIn = (data) => {
    // data.status is guaranteed 'success' here
    const { user_id: userId, onboarding_progress: progress } = data;
    if (progress === "registered") {
      navigate(`/user_verification/${userId}`);
    } else if (progress === "email_verified") {
      const stored = localStorage.getItem('accountType');
      if (stored === 'business') {
        navigate(`/business_plan/${userId}`);
      } else if (stored === 'couple') {
        navigate(`/matching_flow/${userId}`);
      } else {
        navigate(`/dashboard/${userId}`);
      }
    } else {
      navigate(`/dashboard/${userId}`);
    }
  };

  const signInWithEmail = async () => {
    setEmailError('');
    setPasswordError('');
    try {
      const cred = await signInWithEmailAndPassword(auth, email, password);
      const idToken = await cred.user.getIdToken();

      const res = await fetch(
        `https://api.bestday2marry.com/sign_in_user/?idtoken=${encodeURIComponent(idToken)}`,
        { method: "POST", credentials: "include" }
      );
      const data = await res.json();

      if (data.status === 'success') {
        login();                         // <-- only on success
        handlePostSignIn(data);
      } else {
        setEmailError(data.message || 'Unexpected error signing in.');
      }
    } catch (err) {
      console.error(err);
      setEmailError('The email and password you entered did not match our records.');
    }
  };

  const handleGoogleSignIn = async () => {
    setEmailError('');
    try {
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();

      const res = await fetch(
        `https://api.bestday2marry.com/sign_in_user/?idtoken=${encodeURIComponent(idToken)}`,
        { method: "POST", credentials: "include" }
      );
      const data = await res.json();

      if (data.status === 'success') {
        login();                       // <-- only on success
        handlePostSignIn(data);
      } else {
        setEmailError(data.message || 'Google sign-in failed. Please try again.');
      }
    } catch (err) {
      console.error(err);
      setEmailError('Google sign-in failed. Please try again.');
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    let valid = true;

    if (!email) {
      setEmailError('Email is required.');
      valid = false;
    }
    if (!password) {
      setPasswordError('Password is required.');
      valid = false;
    }

    if (valid) signInWithEmail();
  };

  useEffect(() => {
    document.body.classList.add('sign-in-body');
    return () => document.body.classList.remove('sign-in-body');
  }, []);

  return (
    <div className="sign-in-body">
      <div className="sign-in-container">
        <div className="logo"><a href="/">BestDay2Marry</a></div>
        <div className="sign-in-form">
          <h1>Sign In</h1>
          <form onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <input
                type="email"
                placeholder="Email address"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className={emailError ? 'error' : ''}
              />
              {emailError && <div className="error-message">{emailError}</div>}
            </div>

            <div className="form-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className={passwordError ? 'error' : ''}
              />
              {passwordError && <div className="error-message">{passwordError}</div>}
              <div className="forgot-link">
                <button
                  type="button"
                  onClick={() => navigate('/forgot_password')}
                >
                  Forgot password?
                </button>
              </div>
            </div>

            <button type="submit" className="btn btn-primary">
              Log in
            </button>

            <div className="separator">
              <span>Or Continue With</span>
            </div>

            <button
              type="button"
              className="btn-google"
              onClick={handleGoogleSignIn}
            >
              <img src={GoogleLogo} alt="Google logo" />
              Google
            </button>

            <div className="sign-up-container">
              <p id="sign-up-msg">
                Don’t have an account?&nbsp;
                <a href="/signup" className="sign-up-link">Sign up</a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}